import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';

const UserExperiences = () => {
  const [experiences, setExperiences] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchExperiences = async () => {
      try {
        const response = await api.experiences.getAll();
        setExperiences(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error:', error);
        setIsLoading(false);
      }
    };
    fetchExperiences();
  }, []);

  return (
    <section className="mt-12 py-0">
      <div className="container mx-auto">
        <div className="flex justify-center">
          <div className="w-full max-w-4xl">
            {isLoading ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {[1,2,3].map(item => (
                  <div key={item} className="bg-gray-200 dark:bg-gray-700 animate-pulse rounded-lg p-6 min-h-[100px]" />
                ))}
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {experiences.slice().reverse().map((experience) => (
                  <div key={experience.id} className={`${experiences.length === 1 ? 'sm:col-start-2' : ''} cursor-pointer border border-gray-200 dark:border-gray-700 rounded-lg`}>
                    <div 
                      className="bg-white dark:bg-gray-800 rounded-lg p-6 flex flex-col items-center justify-center text-center shadow-md hover:shadow-lg transition-shadow duration-300 min-h-[100px] h-full"
                      onClick={() => window.open(experience.url, '_blank')}
                    >
                      <div className="flex flex-col items-center justify-center h-full">
                        <div className="flex items-center justify-center">
                          <i className={experience.icon} />
                        </div>
                        <h3 className="text-lg font-bold text-blue-500 dark:text-white">
                          {experience.name}
                        </h3>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserExperiences;
